import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

import Vue from "vue"
import mitt from 'mitt'
import axios from "axios";
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vue-multiselect/dist/vue-multiselect.css"
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css';


import "../src/tailwind.css";
import { useToast } from "vue-toastification";
export const toast = useToast();
export const emitter = mitt();

const instance = axios.create({
    withCredentials: true,
});
  
instance.interceptors.request.use(function(config:any) {
    const token = localStorage.getItem('AUTH_ID');
    if(token) {
        // config.headers.common["Authorization"] = 'Bearer ' + token;  
        config.headers.Authorization  = 'Bearer ' + token; 
    }
    return config;
}, function(err:any) {
    return Promise.reject(err);
});

instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken'); 
      // window.location.href = "http://localhost:8080"; 
      window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_RISK_UI}`; 
    }
    return Promise.reject(error);
  });
const app = createApp(App)
app.config.globalProperties.$http = instance;
app.use(store).use(router).use(Toast).use(PrimeVue, {theme: {preset: Aura,options:{ darkModeSelector: '.my-app-dark'},}}).mount('#app');
